import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

import useExternalModals from '../../hooks/useExternalModals';

type Context = ReturnType<typeof useExternalModals>;

const FairValueContext = createContext<Context | null>(null);

export function useFairValueContext() {
  const context = useContext(FairValueContext);

  if (context) {
    return context;
  }

  throw new Error(
    'Attempted to access FairValueContext outside of a FairValueProvider'
  );
}

type ProviderProps = { children: ReactNode };

export const FairValueProvider = ({ children }: ProviderProps) => {
  const value = useExternalModals();

  return (
    <FairValueContext.Provider value={value}>
      {children}
    </FairValueContext.Provider>
  );
};
